module.exports = {
    "inlineSelect": "mc217f7268_inlineSelect",
    "button": "mc217f7268_button",
    "sizeInput": "mc217f7268_sizeInput",
    "lineItem": "mc217f7268_lineItem",
    "item": "mc217f7268_item",
    "input": "mc217f7268_input",
    "sectionContent": "mc217f7268_sectionContent",
    "sectionContentColumn": "mc217f7268_sectionContentColumn",
    "summary": "mc217f7268_summary",
    "submitSection": "mc217f7268_submitSection",
    "configDrive": "mc217f7268_configDrive",
    "configDriveToggle": "mc217f7268_configDriveToggle",
    "refreshNames": "mc217f7268_refreshNames",
    "customConfig": "mc217f7268_customConfig",
    "fixedWidth": "mc217f7268_fixedWidth",
    "tags": "mc217f7268_tags"
};